var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#C5A059"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 33) scale(0.64) translate(-32 -32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7 9.3h26.6v14.7a13.3 13.3 0 01-26.6 0z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3 13.3h8v4.8a8.5 8.5 0 01-8.5 8.5M18.7 13.3h-8v4.8a8.5 8.5 0 008.5 8.5",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 37.3v10.7M21.3 54.7h21.4",
    stroke: "#FFFFFF",
    strokeWidth: 4.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 14.9l2.1 4.3 4.5.5-3.5 3.2.8 4.5-3.9-2.1-3.9 2.1.8-4.5-3.5-3.2 4.5-.5z",
    fill: "#C5A059"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeResult);
export default __webpack_public_path__ + "static/media/badge-result.c0383c5e25cc51f0905bba4c0b1568a7.svg";
export { ForwardRef as ReactComponent };